import { formatEther } from 'ethers'
import { useEffect } from 'react'

import { useToast } from '@chakra-ui/react'
import { useAddRecentTransaction } from '@rainbow-me/rainbowkit'
import { useAccount, useSimulateContract, useWriteContract } from 'wagmi'

import { useTokenxGGPContract } from './contracts/tokenggAVAX'

import { DECODED_ERRORS } from '@/utils/consts'

const useRedeem = (amount: bigint) => {
  const { abi, address } = useTokenxGGPContract()
  const addRecentTransaction = useAddRecentTransaction()
  const { address: userAddress } = useAccount()
  const toast = useToast()
  const simulation = useSimulateContract({
    address,
    abi,
    functionName: 'redeem',
    enabled: amount !== 0n,
    args: [amount, userAddress, userAddress],
    onError(error) {
      Object.keys(DECODED_ERRORS).forEach((key) => {
        if (error?.message.includes(key)) {
          toast({
            position: 'top',
            title: 'Error during redeem of AVAX',
            description: DECODED_ERRORS[key],
            status: 'error',
            duration: 20000,
            isClosable: true,
          })
        }
      })
    },
  })

  const { data: hash, error: writeError, isPending, reset, writeContract } = useWriteContract()

  useEffect(() => {
    if (hash) {
      addRecentTransaction({
        hash: hash,
        description: `Redeem ${formatEther(amount)} AVAX`,
      })
    }
  }, [hash, addRecentTransaction, amount])

  return {
    data: simulation.data,
    isError: simulation.error,
    isLoading: simulation.isLoading,
    refetch: simulation.refetch,
    write: writeContract,
    reset,
    isPending,
    hash,
    writeError,
    ready: writeContract !== undefined,
  }
}

export default useRedeem
